/* global LazyLoad */
import LazyLoad from "vanilla-lazyload";
import inViewObserver from "./in-view-observer";
import scrollbarInit from "./scrollbar";
import footerInit from "./footer";
import headerInit from "./header";

import cursorInit from "./cursor";

import searchInit from "./search";

import customDropdownsInit from "./dropdowns";

function scrollBarInit() {
  const scrollBarInner = document.querySelector(".js-scrollBarInner");
  if (!scrollBarInner) return;

  function updateScrollBar() {
    const scrollScale = window.innerHeight / document.body.offsetHeight;
    const scrollOffset = (100 * window.scrollY) / document.body.offsetHeight;

    scrollBarInner.style.transform = `translateY(${scrollOffset}%) scaleY(${scrollScale})`;
    scrollBarInner.style.webkitTransform = `translateY(${scrollOffset}%) scaleY(${scrollScale})`;
  }

  window.addEventListener("scroll", updateScrollBar);
  updateScrollBar();
}

(function () {
  var lazyLoadInstance = new LazyLoad();
  scrollbarInit();
  footerInit();
  cursorInit();
  scrollBarInit();
  searchInit();
  headerInit();
  customDropdownsInit();

  setTimeout(() => {
    inViewObserver();
  }, 250);
})();
